function Error() {
	return (
		<svg
			version="1.1"
			viewBox="0 0 499.973 391.157"
			xmlns="http://www.w3.org/2000/svg"
			style={{
				width: "100px",
				height: "100px",
				display: "block",
				margin: "0 auto",
			}}
		>
			<g id="cloud-rejected">
				<g id="cloud-rejected_1_">
					<path
						d="M404.141,119.452c-4.312,0-8.528,0.387-12.668,0.945C387.804,53.29,332.262,0,264.256,0    C208.74,0,166.46,40.418,148.992,89.954c-9.311-2.446-24.017-8.668-34.111-8.668C51.428,81.286,0,132.711,0,196.191    c0,63.479,51.428,114.903,114.881,114.903c6.812,0,15.296,0,24.935,0l-7.23,7.208c-7.096,7.123-7.096,18.622-0.016,25.701    l41.817,41.834c3.406,3.411,8.045,5.32,12.85,5.32c4.827,0,9.471-1.909,12.878-5.32l49.852-49.857l49.868,49.857    c3.412,3.411,8.056,5.32,12.861,5.32c4.817,0,9.44-1.909,12.85-5.32l41.834-41.834c7.101-7.08,7.101-18.578,0-25.701l-7.219-7.208    c19.812,0,35.441,0,43.979,0c52.935,0,95.832-42.885,95.832-95.832C499.973,162.359,457.076,119.452,404.141,119.452z     M354.519,331.153l-41.823,41.834l-61.887-61.893l-0.841-0.858l-0.832,0.858l-61.898,61.893l-41.796-41.834l20.085-20.059    l42.627-42.649l-62.712-62.73l41.796-41.812l62.73,62.708l62.708-62.708l41.834,41.812l-62.708,62.708l42.638,42.671    L354.519,331.153z"
						style={{ fill: "#484C4D" }}
					/>
				</g>
			</g>
			<g id="Layer_1" />
		</svg>
	);
}

export default Error;
